<div class="image-editor" >
  <div *ngIf="!isViewAll">
    <!-- Grid Layout View -->
    <div class="editor-content">
      <!-- Grid layout -->
      <div class="block-grid" style="padding: 5px; height: 200px">
        <div
          class="object active-select w-100 h-100"
          [ngClass]="config['classes_image']['grid_class']"
          style="outline: 2px dashed green; padding: 16px"
          [ngStyle]="{
            'justify-content': config['classes_image']['grid_class'] == 'image-video-detail-grid-3' ?
               'space-around' : 'flex-start'
          }"
          (click)="onClickObject('object', $event)"
        >
          <div
            class="main-image"
            style="outline: 2px dashed green"
            (click)="onClickObject('main-image', $event)"
          >
            <!-- Carousel hình ảnh sản phẩm -->
            <div
              class="carousel-layer-image w-100"
              [ngClass]="config['main_image']['effect_carousel_class']"
              [id]="carouselID"
            >
              <div
                class="carousel-layer"
                *ngIf="config['main_image']['is_active_carousel']"
                (mousedown)="onMouseDown(carouselID, $event)"
                (mouseup)="onMouseUp(carouselID, $event)"
                (mouseenter)="onMouseEnter(carouselID, $event)"
                (mousemove)="onMouseMove(carouselID, $event)"
              ></div>
              <!-- carousel inner -->
              <div
                class="carousel-layer-image-inner"
                id="carousel-inner"
                [ngStyle]="{
                  transition:
                    config['main_image']['effect_carousel_duration'] + 's'
                }"
              >
                <div
                  class="item"
                  *ngFor="let item of arrayImage; let i = index"
                  [ngClass]="{ show: counterIndex === i }"
                >
                  {{ item }}
                </div>
              </div>
              <!-- Arrows control -->
              <div
                class="prev-btn"
                *ngIf="config['main_image']['is_active_carousel']"
                [ngStyle]="{
                  opacity:
                    counterIndex === 0 &&
                    config['main_image']['effect_carousel_class'] ==
                      'carousel-transition'
                      ? '0.4'
                      : '1'
                }"
              >
                <i
                  [class]="config['main_image']['arrow_left_icon']"
                  [ngClass]="{
                    'arrow-hover': config['main_image']['is_active_arrow_action']
                  }"
                  [ngStyle]="{
                    color: class['main-image__icon']['color'],
                    'font-size': class['main-image__icon']['font-size'],
                    'background-color': class['main-image__icon']['background-color'],
                    opacity: class['main-image__icon']['opacity']
                  }"
                  (click)="onImagePrev(carouselID)"
                ></i>
              </div>
              <div
                class="next-btn"
                *ngIf="config['main_image']['is_active_carousel']"
                [ngStyle]="{
                  opacity:
                    counterIndex >= arrayImage.length - 1 &&
                    config['main_image']['effect_carousel_class'] ==
                      'carousel-transition'
                      ? '0.4'
                      : '1'
                }"
              >
                <i
                  [class]="config['main_image']['arrow_right_icon']"
                  [ngClass]="{
                    'arrow-hover': config['main_image']['is_active_arrow_action']
                  }"
                  [ngStyle]="{
                    color: class['main-image__icon']['color'],
                    'font-size': class['main-image__icon']['font-size'] + 'px',
                    'background-color': class['main-image__icon']['background-color'],
                    opacity: class['main-image__icon']['opacity'] + '%'
                  }"
                  (click)="onImageNext(carouselID, $event)"
                ></i>
              </div>
            </div>
            <!-- Carousel nhóm hình ảnh nhỏ sản phẩm -->
          </div>
          <div *ngIf="config['classes_image']['grid_class'] != 'image-video-detail-grid-3'"
            class="orther-image"
            style="outline: 2px dashed green"
            (click)="onClickObject('side-image', $event)"
            [ngStyle]="{
              'justify-content': config['side_image']['justify']
            }"
          >
            <div
              class="sm-image square"
              *ngFor="let item of arrayImage; let i = index"
              [ngClass]="{
                actived:
                  counterIndex === i && config['main_image']['is_active_carousel']
              }"
              (click)="gotoImageIndex(carouselID, i)"
            >
              <p
                alt=""
                style="
                  width: 100%;
                  height: 100%;
                  position: absolute;
                  top: 0;
                  left: 0;
                  display: flex;
                  align-items: center;
                  justify-content: center;
                "
              >
                {{ item }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Cài đặt layout grid -->
    <div
      class="editor-content scroll-style"
      style="
        border-top: 1px solid #ddd;
        margin-top: 30px;
        padding: 10px 0px !important;
      "
    >
      <!-- Dropdown menu -->
      <ul nz-menu nzMode="inline">
      
        
        <!-- Cấu hình bố cục object -->
        <li
          nzTitle="Vị trí"
          nzIcon="profile"
          *ngIf="gridObjSelected === 'object'"
        >
          <div class="editor-field">
            <div class="editor-field-body">
              <div class="field-row">
                <div>
                  <p>Bố cục</p>
                  <div class="button-group" style="margin-top: 20px">
                    <nz-radio-group
                      [(ngModel)]="config['classes_image']['grid_class']"
                      class="w-100"
                      style="
                        display: flex;
                        align-items: center;
                        flex-wrap: wrap;
                        gap: calc(51% - 68px);
                      "
                      (ngModelChange)="updateConfig()"
                    >
                      <label
                        nz-radio-button
                        nzValue="image-video-detail-grid-0"
                        style="flex: 1; text-align: center; font-size: 12px; margin-bottom: 12px;"
                        >Kiểu 1</label
                      >
                      
                      <label
                        nz-radio-button
                        nzValue="image-video-detail-grid-1"
                        style="flex: 1; text-align: center; font-size: 12px; margin-bottom: 12px;"
                        >Kiểu 2</label
                      >
                      <label
                        nz-radio-button
                        nzValue="image-video-detail-grid-2"
                        style="flex: 1; text-align: center; font-size: 12px"
                        >Kiểu 3</label
                      >
                      <label
                        nz-radio-button
                        nzValue="image-video-detail-grid-3"
                        style="flex: 1; text-align: center; font-size: 12px"
                        >Kiểu 4</label
                      >
                    </nz-radio-group>
                  </div>
                </div>
              </div>
              <!-- Cấu hình grid layout -->
            </div>
          </div>
        </li>
        <!-- Cấu hình Ảnh chính -->
        <li
          nz-menu
          nzTitle="Thao tác với ảnh chính"
          nzIcon="profile"
          *ngIf="gridObjSelected == 'main-image'"
        >
          <ul nz-menu nzMode="inline">
            <!-- Cài đặt thành phần -->
              <li nz-submenu nzTitle="Cài đặt thành phần">
                <!-- Hiệu ứng chuyển ảnh -->
                <div class="editor-field">
                  <div class="editor-field-body">
                    <!-- Hiệu ứng chuyển ảnh -->
                    <div style="display: flex; flex-wrap: wrap; justify-content: space-between; align-items: flex-end;">
                      <p style="font-weight: 500; font-size: 14px">
                        Hiệu ứng chuyển ảnh
                      </p>
                      <nz-switch 
                        [(ngModel)]="config['main_image']['is_active_carousel']"
                        (ngModelChange)="updateConfig()"
                      ></nz-switch>
                    </div>
                    <!-- Carousel -->
                    <div
                      *ngIf="config['main_image']['is_active_carousel']"
                      class="mt-3"
                    >
                      <div class="field-row">
                        <div class="carousel-slide" id="effect-carousel">
                          <div
                            class="carousel-next"
                            (click)="onNext('effect-carousel', 1)"
                          >
                            <i class="bi bi-chevron-compact-right"></i>
                          </div>
                          <div class="carousel-slide-inner">
                            <div
                              class="item effect"
                              [ngClass]="{
                                actived:
                                  config['main_image'][
                                    'effect_carousel_class'
                                  ] === 'carousel-default'
                              }"
                              (click)="onSelectEffect('default')"
                            >
                              <img
                                src="/assets/root/images/system/icons/effect_slide_default.svg"
                                alt=""
                              />
                            </div>
                            <div
                              class="item effect"
                              [ngClass]="{
                                actived:
                                  config['main_image'][
                                    'effect_carousel_class'
                                  ] === 'carousel-fadeout'
                              }"
                              (click)="onSelectEffect('fade')"
                            >
                              <img
                                src="/assets/root/images/system/icons/effect_slide_fadeout.svg"
                                alt=""
                              />
                            </div>
                            <div
                              class="item effect"
                              [ngClass]="{
                                actived:
                                  config['main_image'][
                                    'effect_carousel_class'
                                  ] === 'carousel-transition'
                              }"
                              (click)="onSelectEffect('transition')"
                            >
                              <img
                                src="/assets/root/images/system/icons/effect_slide_transition.svg"
                                alt=""
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="field-row">
                         <!-- Tự động chuyển -->
                        <div class="config-name mt-0">
                          <p>{{'tu_dong_chuyen' | translate}}</p>
                          <nz-switch [(ngModel)]="config['main_image']['is_autoplay']"
                            (ngModelChange)="updateConfig()"></nz-switch>
                        </div>
                        <div *ngIf="config['main_image']['is_autoplay']">
                          <div class="config-name mb-0">
                            <p>{{'thoi_gian_cho' | translate}} (s)</p>
                            <nz-input-number [nzMin]="0" [nzMax]="50" [nzStep]="1"
                              [(ngModel)]="config['main_image']['time_auto_play']"
                              (nzBlur)="updateConfig()">
                            </nz-input-number>
                          </div>
                          <nz-slider [nzMin]="0" [nzMax]="50" [nzStep]="1"
                              [(ngModel)]="config['main_image']['time_auto_play']"
                              (nzOnAfterChange)="updateConfig()">
                          </nz-slider>
                        </div>
                        <div class="config-name mb-0"
                        >
                          <p style="height: 100%; width:100%; flex: 2;">Thời gian chuyển hiệu ứng</p>
                          <nz-input-number style="flex:1;"
                            [nzMin]="0" [nzMax]="50" [nzStep]="1"
                            [ngModel]="config['main_image']['effect_carousel_duration'] | vhnumber"
                            (ngModelChange)="config['main_image']['effect_carousel_duration'] = $event +'px'"
                            (nzBlur)="updateConfig()">
                          </nz-input-number>
                        </div>
                        <nz-slider [nzMin]="0" [nzMax]="50" [nzStep]="1"
                              [(ngModel)]="config['main_image']['effect_carousel_duration']"
                              (nzOnAfterChange)="updateConfig()">
                        </nz-slider>
                      </div>
                      <!--Cấu hình icon -->
                      <div class="field-row mb-3">
                        <div
                          *ngIf="config['main_image']['is_active_carousel']"
                          class="mt-3"
                        >
                          <!--Cấu hình hiệu ứng icon -->
                          <div class="field-row mb-3">
                            <div
                              style="
                                display: flex;
                                justify-content: space-between;
                                align-items: center;
                                min-height: 30px;
                              "
                            >
                              <p
                                class="m-0"
                                style="font-weight: 500; font-size: 14px"
                              >
                                Icon chuyển ảnh
                              </p>
                            </div>
                          </div>
                          <!-- Hình dạng icon -->
                          <div class="field-row mb-3">
                            <div
                              style="
                                display: flex;
                                justify-content: space-between;
                                align-items: center;
                                height: 100%;
                                min-height: 30px;
                              "
                            >
                              <div class="m-0 h-100">Kiểu</div>
                              <div
                                class="main-image-select-arrows"
                                style="width: 34%"
                              >
                                <button
                                  nz-button
                                  nz-dropdown
                                  [nzDropdownMenu]="menu"
                                  style="width: 100%"
                                  [nzPlacement]="positionSelect"
                                >
                                  <div
                                    style="
                                      font-size: 17px;
                                      display: flex;
                                      justify-content: space-around;
                                    "
                                  >
                                    <i
                                      [class]="
                                        config['main_image']['arrow_left_icon']
                                      "
                                    ></i>
                                    <i
                                      [class]="
                                        config['main_image']['arrow_right_icon']
                                      "
                                    ></i>
                                  </div>
                                </button>
                                <nz-dropdown-menu #menu="nzDropdownMenu">
                                  <ul nz-menu>
                                    <li
                                      nz-menu-item
                                      *ngFor="let item of bootstrapIconArrows"
                                      (click)="onChangeArrows(item)"
                                    >
                                      <div
                                        style="
                                          font-size: 18px;
                                          display: flex;
                                          justify-content: space-around;
                                          padding: 10px 0px;
                                        "
                                      >
                                        <i [class]="item.icon_left"></i>
                                        <i [class]="item.icon_right"></i>
                                      </div>
                                    </li>
                                  </ul>
                                </nz-dropdown-menu>
                              </div>
                            </div>
                          </div>
                          <!-- Kích thước icon -->
                          <div class="field-row mb-3">
                            <div
                              style="
                                display: flex;
                                justify-content: space-between;
                                align-items: center;
                                height: 100%;
                                min-height: 30px;
                              "
                            >
                              <div class="m-0 h-100">{{'kich_thuoc' | translate}}</div>
                              <div style="width: 34%">
                                <nz-input-number
                                  style="border-radius: 2px; width: 100%"
                                  [(ngModel)]="class['main-image__icon']['font-size']"
                                  [nzMin]="1"
                                  [nzMax]="40"
                                  [nzStep]="1"
                                ></nz-input-number>
                              </div>
                            </div>
                          </div>
                          <!-- Màu sắc icon -->
                          <div class="config-name">
                              <p>{{ 'mau_sac' | translate }}</p>
                              <input class="input-color" type="button"
                                  [style.background]="class['main-image__icon']['color']"
                                  [cpOKButton]="true" [(colorPicker)]="class['main-image__icon']['color']"
                                  (colorPickerClose)="updateClass()"/>
                              
                          </div>
                          <!-- Màu nền -->
                          <div class="config-name">
                            <p>{{'mau_nen' | translate}} </p>
                            <input class="input-color" type="button"
                                [style.background]="class['main-image__icon']['background-color']"
                                [cpOKButton]="true" [(colorPicker)]="class['main-image__icon']['background-color']"
                                (colorPickerClose)="updateClass()"/>
                            
                          </div>
                          <!-- Độ mờ -->
                          <div class="field-row mb-3">
                            <div
                              style="
                                display: flex;
                                justify-content: space-between;
                                align-items: center;
                                flex-direction: column;
                              "
                            >
                              <div
                                class="m-0 h-100 w-100"
                                style="
                                  display: flex;
                                  justify-content: space-between;
                                  gap: 10px;
                                  min-height: 35px;
                                "
                              >
                                <p
                                  class="m-0"
                                  style="
                                    display: flex;
                                    align-items: center;
                                    justify-content: center;
                                  "
                                >
                                  Độ trong suốt
                                </p>
                                <p
                                  class="m-0"
                                  *ngIf="opacityArrow === 'icon'"
                                  style="
                                    display: flex;
                                    align-items: center;
                                    justify-content: center;
                                    width: 34%;
                                  "
                                >
                                  <nz-input-number
                                    [(ngModel)]="
                                      class['main-image__icon']['opacity']
                                    "
                                    [nzMin]="0"
                                    [nzMax]="1"
                                    [nzStep]="0.1"
                                    (ngModelChange)="class['main-image__icon']['opacity'] = $event"
                                    (nzOnAfterChange)="updateClass()"
                                  ></nz-input-number>
                                </p>
                                <p
                                  class="m-0"
                                  *ngIf="opacityArrow === 'background'"
                                  style="
                                    display: flex;
                                    align-items: center;
                                    justify-content: center;
                                    width: 34%;
                                  "
                                >
                                  <nz-input-number
                                    [(ngModel)]="
                                      config['main_image'][
                                        'arrow_background_opacity'
                                      ]
                                    "
                                    [nzMin]="0"
                                    [nzMax]="1"
                                    [nzStep]="0.1"
                                    (ngModelChange)="
                                      config['main_image'][
                                        'arrow_background_opacity'
                                      ] = $event
                                    "
                                    (nzOnAfterChange)="updateConfig()"
                                  ></nz-input-number>
                                </p>
                              </div>
                              <div
                                style="
                                  width: 100%;
                                  position: relative;
                                  display: flex;
                                  justify-content: end;
                                  gap: 10px;
                                "
                              >
                                <nz-slider
                                  style="width: 100%"
                                  [nzMin]="0" [nzMax]="1" [nzStep]="0.1"
                                  [(ngModel)]="
                                    class['main-image__icon']['opacity']
                                  "
                                  (ngModelChange)="
                                    class['main-image__icon']['opacity'] = $event
                                  "
                                  (nzOnAfterChange)="updateClass()"
                                  *ngIf="opacityArrow === 'icon'"
                                >
                                </nz-slider>
                                <nz-slider
                                  style="width: 100%"
                                  [nzMin]="0" [nzMax]="1" [nzStep]="0.1"
                                  [(ngModel)]="
                                    config['main_image'][
                                      'arrow_background_opacity'
                                    ]
                                  "
                                  (ngModelChange)="config['main_image']['arrow_background_opacity'] = $event
                                  "
                                  (nzOnAfterChange)="updateConfig()"
                                  *ngIf="opacityArrow === 'background'"
                                >
                                </nz-slider>
                              </div>
                              <div style="width: 100%">
                                <nz-select
                                  [(ngModel)]="opacityArrow"
                                  style="width: 100%"
                                >
                                  <nz-option
                                    nzValue="icon"
                                    nzLabel="Icon"
                                    selected
                                  ></nz-option>
                                  <nz-option
                                    nzValue="background"
                                    nzLabel="Nền icon"
                                  ></nz-option>
                                </nz-select>
                              </div>
                            </div>
                          </div>
                           <!-- Nút mở rộng -->
                          <div class="config-name view-more-btn">
                            <p (click)="openViewAll(style_fields[2])">{{'mo_rong' | translate}} &#8594;</p>
                          </div>
                        </div>
                      </div>
                      <!--Cấu hình hiệu ứng icon -->
                      <div class="config-name m-0"
                          style = "width : 100%">
                        <div
                          style="
                            display: flex;
                            justify-content: space-between;
                            align-items: center;
                            flex:2;
                          "
                        >
                          <p class="m-0" style="font-weight: 500; font-size: 14px">Hiệu ứng icon
                          </p>
                          <nz-switch
                            [(ngModel)]="
                              config['main_image']['is_active_arrow_action']
                            "
                            (ngModelChange)="updateConfig()"
                          ></nz-switch>
                        </div>
                      </div>
                      
                      <div
                        *ngIf="
                          config['main_image']['is_active_carousel'] &&
                          config['main_image']['is_active_arrow_action']
                        "
                        class="mt-3"
                      >
                        <!-- Di chuột vào icon -->
                        <div class="field-row">
                          <!-- Nội dung chỉnh sửa -->
                          <div
                            *ngIf="config['main_image']['is_active_arrow_action']"
                          >
                            <!-- Thời gian chuyển hiệu ứng -->
                            <div
                              class="config-name mb-0"
                            >
                              <p style="height: 100%; width:100%; flex: 2;">Thời gian chuyển hiệu ứng</p>
                              <nz-input-number
                                style="flex:1;"
                                [nzMin]="0"
                                [nzMax]="2.5"
                                [nzStep]="0.1"
                                [(ngModel)]="
                                  config['main_image'][
                                    'arrow_action_hover_duration'
                                  ]
                                "
                                (ngModelChange)="
                                  setVariablesValue(); updateConfig()
                                "
                              ></nz-input-number>
                            </div>
                            <!-- Màu biểu tượng -->"
                            <div class="config-name">
                              <p>{{ 'mau_sac' | translate }}</p>
                              <input class="input-color" type="button"
                                  [style.background]="config['main_image']['arrow_action_hover_color']"
                                  [cpOKButton]="true" [(colorPicker)]="config['main_image']['arrow_action_hover_color']"
                                  (colorPickerClose)="updateConfig()"/>
                              
                            </div>
                          
                            <!-- Màu nền -->
                            <div class="config-name">
                              <p>{{'mau_nen' | translate}} </p>
                              <input class="input-color" type="button"
                                  [style.background]="config['main_image']['arrow_action_hover_background']"
                                  [cpOKButton]="true" [(colorPicker)]="config['main_image']['arrow_action_hover_background']"
                                  (colorPickerClose)="updateConfig()"/>
                              
                            </div>
                            <!-- Độ mờ -->
                            <div class="field-row mb-3">
                              <div
                                style="
                                  display: flex;
                                  justify-content: space-between;
                                  align-items: center;
                                  flex-direction: column;
                                "
                              >
                                <div
                                  class="m-0 h-100 w-100"
                                  style="
                                    display: flex;
                                    justify-content: space-between;
                                    gap: 10px;
                                    min-height: 35px;
                                  "
                                >
                                  <p
                                    class="m-0"
                                    style="
                                      display: flex;
                                      align-items: center;
                                      justify-content: center;
                                    "
                                  >
                                    Độ mờ icon
                                  </p>
                                  <p
                                    class="m-0"
                                    *ngIf="opacityArrowHover === 'icon'"
                                    style="
                                      display: flex;
                                      align-items: center;
                                      justify-content: center;
                                      width: 34%;
                                    "
                                  >
                                  <nz-input-number
                                    [ngModel]="config['main_image']['arrow_action_hover_color_opacity']"
                                    [nzMin]="0"
                                    [nzMax]="1"
                                    [nzStep]="0.1"
                                    (ngModelChange)="config['main_image']['arrow_action_hover_color_opacity'] = $event"
                                    (nzOnAfterChange)="updateConfig()"
                                  ></nz-input-number>
                                    <!-- <nz-input-number
                                      [(ngModel)]="
                                        config['main_image'][
                                          'arrow_action_hover_color_opacity'
                                        ]
                                      "
                                      [nzMin]="1"
                                      [nzMax]="100"
                                      [nzStep]="1"
                                      (ngModelChange)="
                                        onChangeColourOpacity(
                                          'arrow_action_hover_color',
                                          $event
                                        )
                                      "
                                    ></nz-input-number> -->
                                  </p>
                                  <p
                                    class="m-0"
                                    *ngIf="opacityArrowHover === 'background'"
                                    style="
                                      display: flex;
                                      align-items: center;
                                      justify-content: center;
                                      width: 34%;
                                    "
                                  >
                                  <nz-input-number
                                    [ngModel]="config['main_image']['arrow_background_opacity']"
                                    [nzMin]="0"
                                    [nzMax]="1"
                                    [nzStep]="0.1"
                                    (ngModelChange)="config['main_image']['arrow_background_opacity'] = $event"
                                    (nzOnAfterChange)="updateConfig()"
                                  ></nz-input-number>
                                    <!-- <nz-input-number
                                      [(ngModel)]="
                                        config['main_image'][
                                          'arrow_background_opacity'
                                        ]
                                      "
                                      [nzMin]="1"
                                      [nzMax]="100"
                                      [nzStep]="1"
                                      (ngModelChange)="
                                        onChangeColourOpacity(
                                          'arrow_action_hover_background',
                                          $event
                                        )
                                      "
                                    ></nz-input-number> -->
                                  </p>
                                </div>
                                <div
                                  style="
                                    width: 100%;
                                    position: relative;
                                    display: flex;
                                    justify-content: end;
                                    gap: 10px;
                                  "
                                >
                                  <nz-slider
                                    style="width: 100%"
                                    [nzMin]="0" [nzMax]="1" [nzStep]="0.1"
                                    [(ngModel)]="config['main_image']['arrow_action_hover_color_opacity']"
                                    (ngModelChange)="config['main_image']['arrow_action_hover_color_opacity'] = $event"
                                    (nzOnAfterChange)="updateConfig()"
                                    *ngIf="opacityArrowHover === 'icon'"
                                  >
                                  </nz-slider>
                                  <!-- <nz-slider
                                    style="width: 100%"
                                    [(ngModel)]="
                                      config['main_image'][
                                        'arrow_action_hover_color_opacity'
                                      ]
                                    "
                                    (ngModelChange)="
                                      onChangeColourOpacity(
                                        'arrow_action_hover_color',
                                        $event
                                      )
                                    "
                                    *ngIf="opacityArrowHover === 'icon'"
                                  >
                                  </nz-slider> -->
                                  <nz-slider
                                    style="width: 100%"
                                    [nzMin]="0" [nzMax]="1" [nzStep]="0.1"
                                    [(ngModel)]="config['main_image']['arrow_action_hover_background_opacity']"
                                    (ngModelChange)="config['main_image']['arrow_action_hover_background_opacity'] = $event"
                                    (nzOnAfterChange)="updateConfig()"
                                    *ngIf="opacityArrowHover === 'background'"
                                  >
                                  </nz-slider>
                                  <!-- <nz-slider
                                    style="width: 100%"
                                    [(ngModel)]="
                                      config['main_image'][
                                        'arrow_action_hover_background_opacity'
                                      ]
                                    "
                                    (ngModelChange)="
                                      onChangeColourOpacity(
                                        'arrow_action_hover_background',
                                        $event
                                      )
                                    "
                                    *ngIf="opacityArrowHover === 'background'"
                                  >
                                  </nz-slider> -->
                                </div>
                                <div style="width: 100%">
                                  <nz-select
                                    [(ngModel)]="opacityArrowHover"
                                    style="width: 100%"
                                  >
                                    <nz-option
                                      nzValue="icon"
                                      nzLabel="Icon"
                                      selected
                                    ></nz-option>
                                    <nz-option
                                      nzValue="background"
                                      nzLabel="Nền icon"
                                    ></nz-option>
                                  </nz-select>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
               
                <!-- Image zoom -->
                <div class="editor-field">
                  <div class="editor-field-body">
                    <div class="field-row m-0">
                      <div
                        style="
                          display: flex;
                          justify-content: space-between;
                          align-items: center;
                        "
                      >
                        <p class="m-0" style="font-weight: 500; font-size: 14px">
                          Phóng to
                        </p>
                        <nz-switch
                          [(ngModel)]="
                            config['main_image']['is_active_image_zoom']
                          "
                          (ngModelChange)="onZoomSwitch()"
                        ></nz-switch>
                      </div>
                    </div>
                  </div>
                </div>
              </li>
            <!--Cài đặt Hình ảnh-->
              <li nz-submenu nzTitle="Cài đặt Hình ảnh">
                <atw-image-video-detail-image-admin-config
                  [objectChoosing]="objectChoosing"
                  [staticdata]="staticdata"
                  [config]="config"
                  [class]="class"
                  [device]="device"
                >
                </atw-image-video-detail-image-admin-config>
              </li>
          </ul>
        </li>
  
        <!-- Cấu hình Danh sách ảnh khác -->
        <li
          nz-menu
          nzTitle="Danh sách ảnh khác"
          nzIcon="profile"
          *ngIf="gridObjSelected == 'side-image'"
        >
  
          <ul nz-menu nzMode="inline">
            <!-- Thay đổi vị trí nhóm ảnh -->
              <li *ngIf="config['classes_image']['grid_class'] != 'image-video-detail-grid-3'" 
                  nz-submenu nzTitle="Thay đổi vị trí nhóm ảnh">
                <!-- Hiệu ứng chuyển ảnh -->
                <div class="editor-field">
                  <div class="editor-field-body">
                    <div class="field-row mb-3">
                      <div>
                        <!-- thay đổi vị trí ảnh cho kiểu 1 và 2 -->
                        <div *ngIf="config['classes_image']['grid_class'] == 'image-video-detail-grid-0'
                                    || config['classes_image']['grid_class'] == 'image-video-detail-grid-1'">
                          <nz-radio-group
                            [(ngModel)]="config['side_image']['justify']"
                            (ngModelChange)="updateConfig()"
                            style="
                              display: flex;
                              align-items: center;
                              justify-content: end;
                              gap: calc(50% - 68px);
                              flex-wrap: wrap;
                            "
                          >
                            <label
                              nz-radio-button
                              nzValue="flex-start"
                              style="flex: 1; text-align: center; font-size: 13px"
                              >Trên</label>
                            <label
                              nz-radio-button
                              nzValue="center"
                              style="
                                flex: 1;
                                text-align: center;
                                /* flex-basis: 24%; */
                                font-size: 13px;
                              "
                              >Giữa</label>
                            <label
                              nz-radio-button
                              nzValue="flex-end"
                              style="flex: 1; text-align: center; font-size: 13px; margin-top:13px"
                              >Dưới</label>
                            <label
                              nz-radio-button
                              nzValue="space-between"
                              style="
                                flex: 1;
                                text-align: center;
                                /* white-space: nowrap; */
                                font-size: 13px;
                                margin-top:13px
                              "
                              >Căn đều</label>
                          </nz-radio-group>
                        </div>
                        <!-- thay đổi vị trí ảnh cho kiểu 3-->
                        <div *ngIf="config['classes_image']['grid_class'] == 'image-video-detail-grid-2'">
                          <nz-radio-group
                            [(ngModel)]="config['side_image']['justify']"
                            (ngModelChange)="updateConfig()"
                            style="
                              display: flex;
                              align-items: center;
                              justify-content: end;
                              gap: calc(50% - 68px);
                              flex-wrap: wrap;
                            "
                          >
                            <label
                              nz-radio-button
                              nzValue="flex-start"
                              style="flex: 1; text-align: center; font-size: 13px"
                              >Trái</label>
                            <label
                              nz-radio-button
                              nzValue="center"
                              style="
                                flex: 1;
                                text-align: center;
                                /* flex-basis: 24%; */
                                font-size: 13px;
                              "
                              >Giữa</label>
                            <label
                              nz-radio-button
                              nzValue="flex-end"
                              style="flex: 1; text-align: center; font-size: 13px; margin-top:13px"
                              >Phải</label>
                            <label
                              nz-radio-button
                              nzValue="space-between"
                              style="
                                flex: 1;
                                text-align: center;
                                /* white-space: nowrap; */
                                font-size: 13px;
                                margin-top:13px;
                              "
                              >Căn đều</label>
                          </nz-radio-group>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                    
              </li>
              <!-- set kiểu viền và màu viền nhóm ảnh nhỏ-->
              <li nz-submenu nzTitle="Đường viền nhóm ảnh nhỏ">
                <app-borders-config [elementChoosing]="objectChoosing" [device]="device"
                            [class]="class"
                            [borderClass]="class['orther-image']"
                            [id_object]="objectChoosing._id"
                >
                </app-borders-config>
                
                <!-- Nút mở rộng -->
                <div class="config-name view-more-btn">
                  <p (click)="openViewAll(style_fields[0])">{{'mo_rong' | translate}} &#8594;</p>
                </div>
              </li>

              <!-- set kiểu viền và màu viền cho phần selected-->
              <li nz-submenu nzTitle="Đường viền khung khi chọn">
                <div class="editor-field" 
                    style=" display: flex; flex-wrap: wrap; justify-content: space-between; align-items: center;">
                  <p class="m-0 item-border" >Kiểu viền</p>
                  <div class="field-widget">
                    <button nz-dropdown nzTrigger="click" [nzDropdownMenu]="menuBorder1" nzPopoverTrigger="click">
                      <mat-icon>border_style</mat-icon>
                    </button>
                  </div>
                  <!-- Menu các kiểu viền khác -->
                  <nz-dropdown-menu #menuBorder1="nzDropdownMenu">
                    <ul nz-menu>
                      <!-- Kiểu viền solid -->
                      <li nz-menu-item>
                        <button (click)="config['image_actived']['outline_style']  = 'solid'; updateConfig()" nz-tooltip
                          nzTooltipTitle="Solid" nzTooltipPlacement="left" class="widget-button"
                          [ngClass]="{'active': config['image_actived']['outline_style']  == 'solid'}">
                          <div class="icon-field">
                            <svg width="16px" height="16px" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path fill-rule="evenodd" clip-rule="evenodd"
                                d="M1.25 7.5C1.25 7.22386 1.47386 7 1.75 7H13.25C13.5261 7 13.75 7.22386 13.75 7.5C13.75 7.77614 13.5261 8 13.25 8H1.75C1.47386 8 1.25 7.77614 1.25 7.5Z"
                                fill="#000000" />
                            </svg>
                          </div>
                        </button>
                      </li>
                      <!-- Kiểu viền double -->
                      <li nz-menu-item>
                        <button (click)="config['image_actived']['outline_style']  = 'double'; updateConfig()" nz-tooltip
                          nzTooltipTitle="Double" nzTooltipPlacement="left" class="widget-button"
                          [ngClass]="{'active': config['image_actived']['outline_style']  == 'double'}">
                          <div class="icon-field">
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                              class="bi bi-border-style" viewBox="0 0 16 16">
                              <path
                                d="M1 3.5a.5.5 0 0 1 .5-.5h13a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-13a.5.5 0 0 1-.5-.5v-1zm0 4a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-5a.5.5 0 0 1-.5-.5v-1zm0 4a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1zm8 0a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1zm-4 0a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1zm8 0a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1zm-4-4a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-5a.5.5 0 0 1-.5-.5v-1z" />
                            </svg>
                          </div>
                        </button>
                      </li>
                      <!-- Kiểu viền dashed -->
                      <li nz-menu-item>
                        <button (click)="config['image_actived']['outline_style']  = 'dashed'; updateConfig()" nz-tooltip
                          nzTooltipTitle="Dashed" nzTooltipPlacement="left" class="widget-button"
                          [ngClass]="{'active': config['image_actived']['outline_style']  == 'dashed'}">
                          <div class="icon-field">
                            <svg width="16px" height="16px" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path fill-rule="evenodd" clip-rule="evenodd"
                                d="M0 7.5C0 7.22386 0.223858 7 0.5 7H3C3.27614 7 3.5 7.22386 3.5 7.5C3.5 7.77614 3.27614 8 3 8H0.5C0.223858 8 0 7.77614 0 7.5ZM5.75 7.5C5.75 7.22386 5.97386 7 6.25 7H8.75C9.02614 7 9.25 7.22386 9.25 7.5C9.25 7.77614 9.02614 8 8.75 8H6.25C5.97386 8 5.75 7.77614 5.75 7.5ZM12 7C11.7239 7 11.5 7.22386 11.5 7.5C11.5 7.77614 11.7239 8 12 8H14.5C14.7761 8 15 7.77614 15 7.5C15 7.22386 14.7761 7 14.5 7H12Z"
                                fill="#000000" />
                            </svg>
                          </div>
                        </button>
                      </li>
                      <!-- Kiểu viền dotted -->
                      <li nz-menu-item>
                        <button (click)="config['image_actived']['outline_style']  = 'dotted'; updateConfig()" nz-tooltip
                          nzTooltipTitle="Dotted" nzTooltipPlacement="left" class="widget-button"
                          [ngClass]="{'active': config['image_actived']['outline_style']  == 'dotted'}">
                          <div class="icon-field">
                            <i class="bi bi-three-dots"></i>
                          </div>
                        </button>
                      </li>
                    </ul>
                  </nz-dropdown-menu>
                </div>
                <div class="item-border-size">
                  <!-- Điều chỉnh kích thước viền trên -->
                  <div class="config-name mb-0">
                    <p>{{'kich_thuoc' | translate}}</p>
                    <nz-input-number [nzMin]="0" [nzMax]="10"
                      [ngModel]="config['image_actived']['outline_width'] | vhnumber"
                      (ngModelChange)="config['image_actived']['outline_width'] = $event +'px'"
                      (nzBlur)="updateConfig()">
                    </nz-input-number>
                  </div>
                  <nz-row>
                    <nz-col nzSpan="24">
                      <nz-slider [nzMin]="0" [nzMax]="10"
                        [ngModel]="config['image_actived']['outline_width'] | vhnumber"
                        (ngModelChange)="config['image_actived']['outline_width'] = $event +'px'"
                        (nzOnAfterChange)="updateConfig()">
                      </nz-slider>
                    </nz-col>
                  </nz-row>
                </div>
                <!-- Lựa chọn màu viền -->
                <div class="config-name">
                  <p>{{'mau_vien' | translate}} </p>
                  <input class="input-color" type="button"
                    [style.background]="config['image_actived']['outline_color']"
                    [cpOKButton]="true" [(colorPicker)]="config['image_actived']['outline_color']"
                    (colorPickerClose)="updateConfig()" />
                </div>
                <!-- Nút mở rộng -->
                <!-- <div class="config-name view-more-btn">
                  <p (click)="openViewAll(style_fields[0])">{{'mo_rong' | translate}} &#8594;</p>
                </div> -->
              </li>

              <!-- Set kích thước cho nhóm ảnh nhỏ -->
              <li nz-submenu nzTitle="Kich Thước nhóm ảnh">
                <div class="editor-field">
                  <div class="editor-field-body">
                    <!-- width >=630 and < 837 -->
                    <div *ngIf="config['classes_image']['grid_class'] != 'image-video-detail-grid-2'" class="field-row">
                     <div
                         style="
                           display: flex; flex-wrap: wrap; justify-content: space-between; align-items: center;
                         "
                       >
                         <p class="m-0">{{'kich_thuoc' | translate}}</p>
                         <nz-input-number [nzMin]="0" [nzMax]="100"
                           [ngModel]="config['other_image']['width'] | vhnumber"
                           (ngModelChange)="config['other_image']['width'] = $event +'px'"
                           (nzOnAfterChange)="updateConfig()">
                         </nz-input-number>
                       </div>
                       <nz-row>
                         <nz-col nzSpan="24">
                           <nz-slider [nzMin]="0" [nzMax]="100"
                             [ngModel]="config['other_image']['width'] | vhnumber"
                             (ngModelChange)="config['other_image']['width'] = $event +'px'"
                             (nzOnAfterChange)="updateConfig()">
                           </nz-slider>
                         </nz-col>
                       </nz-row>
                   </div>
                    <!-- điều chỉnh kích thước cho kiểu grid 3 -->
                    <div *ngIf="config['classes_image']['grid_class'] == 'image-video-detail-grid-2'" class="field-row">
                      <div
                        style="
                          display: flex; flex-wrap: wrap; justify-content: space-between; align-items: center;
                        "
                      >
                        <p class="m-0">{{'kich_thuoc' | translate}}</p>
                        <nz-input-number [nzMin]="0" [nzMax]="150"
                          [ngModel]="config['other_image_grid_2']['width'] | vhnumber"
                          (ngModelChange)="config['other_image_grid_2']['width'] = $event +'%'"
                          (nzOnAfterChange)="updateConfig()">
                        </nz-input-number>
                      </div>
                      <nz-row>
                        <nz-col nzSpan="24">
                          <nz-slider [nzMin]="0" [nzMax]="150"
                            [ngModel]="config['other_image_grid_2']['width'] | vhnumber"
                            (ngModelChange)="config['other_image_grid_2']['width'] = $event +'%'" 
                            (nzOnAfterChange)="updateConfig()">
                          </nz-slider>
                        </nz-col>
                      </nz-row>
                    </div>

                  </div>
                </div>
              </li>

              <!-- Cấu hình Icon nhóm ảnh nhỏ-->
              <li nz-submenu nzTitle="Icon chuyển ảnh">
                <!-- Hình dạng icon -->
                <div class="field-row mb-3">
                  <div
                    style="
                      display: flex;
                      justify-content: space-between;
                      align-items: center;
                      height: 100%;
                      min-height: 30px;
                    "
                  >
                    <div class="m-0 h-100">Kiểu</div>
                    <!-- dành cho kiểu 1 & 2 -->
                    <div
                      *ngIf="config['classes_image']['grid_class'] != 'image-video-detail-grid-2'"
                      class="main-image-select-arrows"
                      style="width: 34%"
                    >
                      <button
                        nz-button
                        nz-dropdown
                        [nzDropdownMenu]="menu"
                        style="width: 100%"
                        [nzPlacement]="positionSelect"
                      >
                        <div
                          style="
                            font-size: 17px;
                            display: flex;
                            justify-content: space-around;
                          "
                        >
                          <i
                            [class]="
                              config['other_image']['arrow_up_icon']
                            "
                          ></i>
                          <i
                            [class]="
                              config['other_image']['arrow_down_icon']
                            "
                          ></i>
                        </div>
                      </button>
                      <nz-dropdown-menu #menu="nzDropdownMenu">
                        <ul nz-menu>
                          <li
                            nz-menu-item
                            *ngFor="let item of bootstrapIconArrowsUpDown"
                            (click)="onChangeArrowsUpDown(item)"
                          >
                            <div
                              style="
                                font-size: 18px;
                                display: flex;
                                justify-content: space-around;
                                padding: 10px 0px;
                              "
                            >
                              <i [class]="item.icon_up"></i>
                              <i [class]="item.icon_down"></i>
                            </div>
                          </li>
                        </ul>
                      </nz-dropdown-menu>
                    </div>

                    <!-- dành cho kiểu 3 -->
                    <div
                      *ngIf="config['classes_image']['grid_class'] == 'image-video-detail-grid-2'"
                      class="main-image-select-arrows"
                      style="width: 34%"
                    >
                      <button
                        nz-button
                        nz-dropdown
                        [nzDropdownMenu]="menu"
                        style="width: 100%"
                        [nzPlacement]="positionSelect"
                      >
                        <div
                          style="
                            font-size: 17px;
                            display: flex;
                            justify-content: space-around;
                          "
                        >
                          <i
                            [class]="
                              config['other_image']['arrow_left_icon']
                            "
                          ></i>
                          <i
                            [class]="
                              config['other_image']['arrow_right_icon']
                            "
                          ></i>
                        </div>
                      </button>
                      <nz-dropdown-menu #menu="nzDropdownMenu">
                        <ul nz-menu>
                          <li
                            nz-menu-item
                            *ngFor="let item of bootstrapIconArrows"
                            (click)="onChangeArrowsGrid2(item)"
                          >
                            <div
                              style="
                                font-size: 18px;
                                display: flex;
                                justify-content: space-around;
                                padding: 10px 0px;
                              "
                            >
                              <i [class]="item.icon_left"></i>
                              <i [class]="item.icon_right"></i>
                            </div>
                          </li>
                        </ul>
                      </nz-dropdown-menu>
                    </div>

                  </div>
                </div>
                <!-- Kích thước icon -->
                <div class="field-row mb-3">
                  <div
                    style="
                      display: flex;
                      justify-content: space-between;
                      align-items: center;
                      height: 100%;
                      min-height: 30px;
                    "
                  >
                    <div class="m-0 h-100">{{'kich_thuoc' | translate}}</div>
                    <div style="width: 34%">
                      <nz-input-number
                        style="border-radius: 2px; width: 100%"
                        [(ngModel)]="config['other_image']['arrow_size']"
                        [nzMin]="1"
                        [nzMax]="40"
                        [nzStep]="1"
                      ></nz-input-number>
                    </div>
                  </div>
                </div>
                <!-- Màu sắc icon -->
                <div class="config-name">
                    <p>{{ 'mau_sac' | translate }}</p>
                    <div style="width: 34%">
                      <input class="input-color" type="button"  style="width: 100%"
                      [style.background]="config['other_image']['arrow_color']"
                      [cpOKButton]="true" [(colorPicker)]="config['other_image']['arrow_color']"
                      (colorPickerClose)="updateConfig()"/>
                    </div>
                </div>
                <!-- Màu nền -->
                <div class="config-name">
                  <p>{{'mau_nen' | translate}} </p>
                  <input class="input-color" type="button"
                      [style.background]="config['other_image']['arrow_background']"
                      [cpOKButton]="true" [(colorPicker)]="config['other_image']['arrow_background']"
                      (colorPickerClose)="updateConfig()"/>
                  
                </div>
                <!-- Độ mờ -->
                <div class="field-row mb-3">
                  <div
                    
                  >
                    <div class="config-name">
                      <p>Độ trong suốt</p>
                      <nz-input-number [nzMin]="0" [nzMax]="1" [nzStep]="0.1"
                        [ngModel]="config['other_image']['arrow_color_opacity'] | vhnumber"
                        (ngModelChange)="config['other_image']['arrow_color_opacity'] = $event"
                        (nzOnAfterChange)="updateConfig()">
                      </nz-input-number>
                    </div>
                    <div>
                      <nz-slider [nzMin]="0" [nzMax]="1" [nzStep]="0.1"
                        [ngModel]="config['other_image']['arrow_color_opacity'] | vhnumber"
                        (ngModelChange)="config['other_image']['arrow_color_opacity'] = $event"
                        (nzOnAfterChange)="updateConfig()">
                      </nz-slider>
                    </div>
                    <div style="width: 100%">
                      <nz-select
                        [(ngModel)]="opacityArrow"
                        style="width: 100%"
                      >
                        <nz-option
                          nzValue="icon"
                          nzLabel="Icon"
                          selected
                        ></nz-option>
                        <nz-option
                          nzValue="background"
                          nzLabel="Nền icon"
                        ></nz-option>
                      </nz-select>
                    </div>
                     
                  </div>
                </div>
                <!-- Nút mở rộng cho ảnh nhỏ-->
                <div class="config-name view-more-btn">
                  <p (click)="openViewAll(style_fields[3])">{{'mo_rong' | translate}} &#8594;</p>
                </div>
              </li>

              <!-- Set số lượng cho nhóm ảnh nhỏ -->
              <li nz-submenu nzTitle="Số lượng ảnh hiện">
                <div class="editor-field">
                  <div class="editor-field-body">
                    <div class="field-row">
                     <div
                         style="
                           display: flex; flex-wrap: wrap; justify-content: space-between; align-items: center;
                         "
                       >
                         <p class="m-0">Số lượng</p>
                         <nz-input-number [nzMin]="0" [nzMax]="8"
                           [ngModel]="config['other_image']['total_image_show'] | vhnumber"
                           (ngModelChange)="config['other_image']['total_image_show'] = $event"
                           (nzOnAfterChange)="updateConfig()">
                         </nz-input-number>
                       </div>
                       <nz-row>
                         <nz-col nzSpan="24">
                           <nz-slider [nzMin]="0" [nzMax]="8"
                             [ngModel]="config['other_image']['total_image_show'] | vhnumber"
                             (ngModelChange)="config['other_image']['total_image_show'] = $event"
                             (nzOnAfterChange)="updateConfig()">
                           </nz-slider>
                         </nz-col>
                       </nz-row>
                   </div>

                  </div>
                </div>
              </li>

              <!-- Cấu hình object-fit -->
              <li nz-submenu nzTitle="Độ bao phủ ">
                <app-object-fit-config
                  [device]="device"
                  [class]="class"
                  [style_field]="style_fields[1]"
                  [objectFitClass]="class['orther-image']"
                  (isViewAll)="isOpenViewAll($event)"
                  [objectChoosing]="objectChoosing">
                </app-object-fit-config>
              </li>
          </ul>
        </li>
      </ul>
    </div>
  </div>

  <div class="editor-content" *ngIf="isViewAll">
    <div
      class="return"
      (click)="isViewAll = !isViewAll"
      style="
        display: flex;
        align-items: center;
        gap: 10px;
        cursor: pointer;
        margin-bottom: 5px;
        text-transform:uppercase;
        text-decoration: underline;
      "
    >
        <i class="bi bi-chevron-left" (click)="isViewAll = !isViewAll"></i>
        <span (click)="isViewAll = !isViewAll" 
              style="font-weight: 500;">
            {{currentViewAll.title | translate}}</span>
      </div>
  </div>

  <div class="view-more" *ngIf="isViewAll">
    <!-- Cấu hình chi tiết viền của phần tử trong frame -->
    <div class="view_more-border" *ngIf="currentViewAll.index == 1">
      <app-borders-radius-config
                    [elementChoosing]="objectChoosing"
                    [device]="device"
                    [class]="class"
                    [borderRadiusClass]="class['orther-image']"
                    [id_object]="objectChoosing._id"
      >
      </app-borders-radius-config>
    </div>

    <!-- Mở rộng cấu hình độ bao phủ -->
    <div class="editor-field-body p-1" *ngIf="currentViewAll.index == 2">
      <div class="field-row">
        <div
          style="
            display: flex;
            justify-content: space-between;
            align-items: center;
          "
        >
          <p class="m-0" style="font-weight: 500; font-size: 14px">
            Vị trí hình ảnh
          </p>
        </div>
      </div>
      <div class="field-row">
        <div
          style="
            display: flex;
            justify-content: space-between;
            align-items: center;
          "
        >
          <p class="m-0">Ngang</p>
          <nz-input-number
            [(ngModel)]="config['object_fit_image']['object_x']"
            [nzMin]="0"
            [nzStep]="1"
            (ngModelChange)="handleSetPositionImage()"
            style="width: 40%"
          ></nz-input-number>
        </div>
        <nz-slider
          [(ngModel)]="config['object_fit_image']['object_x']"
          (ngModelChange)="handleSetPositionImage()"
        ></nz-slider>
      </div>
      <div class="field-row">
        <div
          style="
            display: flex;
            justify-content: space-between;
            align-items: center;
          "
        >
          <p class="m-0">Dọc</p>
          <nz-input-number
            [nzStep]="1"
            [(ngModel)]="config['object_fit_image']['object_y']"
            (ngModelChange)="handleSetPositionImage()"
            style="width: 40%"
          ></nz-input-number>
        </div>
        <nz-slider
          [(ngModel)]="config['object_fit_image']['object_y']"
          (ngModelChange)="handleSetPositionImage()"
        ></nz-slider>
      </div>
      <!-- <div class="field-row">
        <div
          style="
            display: flex;
            justify-content: space-between;
            align-items: center;
          "
        >
          <p class="m-0" style="font-weight: 500; font-size: 14px">
            Phóng/Thu hình ảnh
          </p>
        </div>
    </div> -->
    </div>

    <!-- Cấu hình chi tiết viền của icon ảnh chính -->
    <div class="view_more-border" *ngIf="currentViewAll.index == 3">
      <app-borders-radius-config
                    [elementChoosing]="objectChoosing"
                    [device]="device"
                    [class]="class"
                    [borderRadiusClass]="class['main-image__icon']"
                    [id_object]="objectChoosing._id"
      >
      </app-borders-radius-config>
    </div>

    <!-- Cấu hình chi tiết viền của icon của nhóm ảnh nhỏ -->
    <div class="view_more-border" *ngIf="currentViewAll.index == 4">
      <app-borders-radius-config
      [elementChoosing]="objectChoosing"
                    [device]="device"
                    [class]="class"
                    [borderRadiusClass]="config['border_other_image']"
                    [id_object]="objectChoosing._id"
      >
      </app-borders-radius-config>
    </div>
</div>
